// This file is automatically generated. Do not edit manually.

import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOrderLineReservationFormApi {
	export async function fetchInitData(args: {
		partIds: Array<number>;
		onlyFromOwnWarehouseArea: boolean;
	}): Promise<CustomerOrderLineReservationFormApi_InitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/picking/CustomerOrderLineReservationForm/fetchInitData",
			method: "POST",
			data: {
				partIds: args.partIds,
				onlyFromOwnWarehouseArea: args.onlyFromOwnWarehouseArea,
			},
		});
		return response as CustomerOrderLineReservationFormApi_InitData;
	}

	export async function createReservations(args: {
		reservationRequests: Array<CustomerOrderLineReservationFormApi_ReservationRequest>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/picking/CustomerOrderLineReservationForm/createReservations",
			method: "POST",
			data: {
				reservationRequests: args.reservationRequests,
			},
		});
		return response as void;
	}
}

export interface CustomerOrderLineReservationFormApi_InitData {
	partWarehouseLocationOptionsByPartIds: Record<
		number,
		Array<CustomerOrderLineReservationFormApi_PartWarehouseLocationDto>
	>;
}

export interface CustomerOrderLineReservationFormApi_PartWarehouseLocationDto {
	inventoryLevelEnabled: boolean;
	partWarehouseLocationCode: string;
	partWarehouseLocationId: number;
	partWarehouseUnit: string;
	reservedQuantity: number | null | undefined;
	stockQuantity: number | null | undefined;
}

export interface CustomerOrderLineReservationFormApi_ReservationRequest {
	customerOrderLineId: number;
	partWarehouseLocationId: number | null | undefined;
	quantityInWarehouseUnit: number;
}
